import { Injectable } from '@angular/core';
import { ShowAlert } from '@app/core/actions/alert';
import { InfoMessage } from '@app/core/models/alert/info-message';
import {
  ExportDossierSearchResults,
  ExportDossierSearchResultsActionTypes,
  ExportDossierSearchResultsFail
} from '@app/pcs/actions/export-dossier-search-results';
import { GridType } from '@app/pcs/models';
import { SearchReportType } from '@app/pcs/models/search-report-type';
import { ExportSearchResultsReportService } from '@app/pcs/services/export-search-results-report.service';
import { GridService } from '@app/pcs/services/grid.service';
import { toDossierIds } from '@app/pcs/util';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { mapPayload } from '@util';
import { of } from 'rxjs';
import { catchError, exhaustMap, switchMap, withLatestFrom } from 'rxjs/operators';

@Injectable()
export class ExportDossierSearchResultsEffects {

  $exportDossierSearchResults$ = createEffect(() => this.actions$.pipe(
    ofType<ExportDossierSearchResults>(ExportDossierSearchResultsActionTypes.ExportDossierSearchResults),
    mapPayload(),
    withLatestFrom(this.gridService.getSelectedIds(GridType.Search, toDossierIds), this.gridService.getGridVisibleColumnNames(GridType.Search)),
    exhaustMap(([exportOptions, ids, columns]) =>
      this.exportSearchResultsReportService.export({
        ...exportOptions,
        ids,
        columns
      }, SearchReportType.DossierSearchResultsReport).pipe(
        switchMap(() => of(new ShowAlert(new InfoMessage('report.request.generate.note')))),
        catchError((error: Error) => of(new ExportDossierSearchResultsFail(error)))
      )
    )
  ));

  constructor(
    private actions$: Actions,
    private gridService: GridService,
    private exportSearchResultsReportService: ExportSearchResultsReportService
  ) {
  }
}
